import Layout from "@/components/layout/Layout";
import Button from "@/components/ui/Button";

import TextField from "@/components/ui/Textfield";
import React, { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { useShallow } from "zustand/react/shallow";
import useManageMediaAgencyStore from "./store/mediaAgency";
import Spinner from "@/components/ui/Spinner";
import useGlobalStore from "@/store/globalStore";

export const ManageMediaAgency: React.FC = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [isLoading, setIsLoading] = useState(false);

  const { fetchAgency, agency } = useManageMediaAgencyStore(
    useShallow((state) => ({
      fetchAgency: state.fetchAgency,
      agency: state.agency,
    }))
  );

  const setError = useGlobalStore((state) => state.setError);

  //   const filteredPeople = agency agency?.data?.filter(
  //     (p) =>
  //       p.name.toLowerCase().includes(search.toLowerCase()) ||
  //       p.size.toLowerCase().includes(search.toLowerCase())
  //   );

  const fetchData = async (page?: number) => {
    setIsLoading(true);
    try {
      const pageToFetch = page ?? currentPage;
      await fetchAgency(pageToFetch.toString());
    } catch (error) {
      setError(error instanceof Error ? error.message : "Unknown error");
    } finally {
      setIsLoading(false);
    }
  };

  const goPrevious = async () => {
    const newPage = Math.max(currentPage - 1, 1);
    setCurrentPage(newPage);
    await fetchData(newPage);
  };

  const goNext = async () => {
    const lastPage = agency.meta?.last_page || 1;
    const newPage = Math.min(currentPage + 1, lastPage);
    setCurrentPage(newPage);
    await fetchData(newPage);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Layout>
      <div>
        <h1 className="text-2xl font-bold mb-8">Media Agency</h1>

        <div className="flex justify-between mb-6">
          <div>
            <TextField
              type="text"
              leadingIcon={<BiSearch />}
              placeholder="Search by keyword, name, etc."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-96"
            />
          </div>
        </div>

        <div className="grid grid-cols-12 border-b border-gray-300 pb-2 mb-2 text-sm text-gray-700 select-none">
          <div className="col-span-3 flex items-center cursor-pointer gap-1">
            Name
            <svg
              className="w-4 h-4 text-pink-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <div className="col-span-3 flex items-center cursor-pointer gap-1">
            Email
            <svg
              className="w-4 h-4 text-pink-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <div className="col-span-3 flex items-center cursor-pointer gap-1">
            Industry
            <svg
              className="w-4 h-4 text-pink-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <div className="col-span-1 flex items-center cursor-pointer gap-1">
            Size
            <svg
              className="w-4 h-4 text-pink-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          <div className="col-span-2 flex items-center cursor-pointer gap-1">
            Phone
            <svg
              className="w-4 h-4 text-pink-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
        </div>

        <div className="divide-y divide-gray-300">
          {agency == null ? (
            <div className="flex justify-center mt-10">
              <Spinner />
            </div>
          ) : (
            agency.data.map((ag) => {
              return (
                <div
                  key={ag.id}
                  className="grid grid-cols-12 items-center py-3 text-sm"
                >
                  <div className="col-span-3 flex items-center gap-3">
                    <div>{ag.name}</div>
                  </div>
                  <div className="col-span-3">{ag.main_email}</div>
                  <div className="col-span-3">{ag.industry}</div>
                  <div className="col-span-1">{ag.size}</div>
                  <div className="col-span-2">{ag.phone}</div>
                </div>
              );
            })
          )}
        </div>

        {agency !== null && (
          <div className="flex justify-end items-center mt-6 space-x-4 text-sm">
            <Button
              type="secondary"
              onClick={goPrevious}
              disabled={currentPage === 1}
            >
              Previous
            </Button>
            <span>
              Page {currentPage} of {agency.meta.last_page || 1}
            </span>
            <Button
              type="secondary"
              onClick={goNext}
              disabled={
                currentPage === agency.meta.last_page ||
                agency.meta.last_page === 0
              }
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ManageMediaAgency;
